module.exports = __webpack_public_path__ + "img/promenade_cathedrale.14f61d41.webp";